var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-confirm" },
    [
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, closeOnClickOverlay: "true" },
          on: { close: _vm.close },
          model: {
            value: _vm.showDiaC,
            callback: function ($$v) {
              _vm.showDiaC = $$v
            },
            expression: "showDiaC",
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _vm.headline
              ? _c("div", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.headline)),
                ])
              : _vm._e(),
            _vm.title
              ? _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
              : _vm._e(),
            _c("div", { staticClass: "btn" }, [
              _vm.oneShow
                ? _c(
                    "div",
                    { staticClass: "one", on: { click: _vm.handleGot } },
                    [_vm._v(_vm._s(_vm.$t("lang.gotit")))]
                  )
                : _c("div", { staticClass: "two" }, [
                    _c(
                      "span",
                      {
                        staticClass: "confirm-think",
                        on: { click: _vm.handleThinK },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.think")))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "confirm-btn",
                        on: { click: _vm.handleConfirm },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.confirm")))]
                    ),
                  ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }